import { __decorate, __metadata } from "tslib";
import { AngularVelocityUnit } from '../../utils/unit/AngularVelocityUnit';
import { SerializableObject, SerializableMember } from '../decorators';
import { SensorValue } from './SensorValue';
/**
 * @category Sensor Value
 */
let AngularVelocity = class AngularVelocity extends SensorValue {
  constructor(x, y, z, unit = AngularVelocityUnit.RADIAN_PER_SECOND) {
    super(x, y, z, unit, AngularVelocityUnit.RADIAN_PER_SECOND);
  }
  static fromArray(array, unit = AngularVelocityUnit.RADIAN_PER_SECOND) {
    return new this(array[0], array[1], array[2], unit);
  }
};
__decorate([SerializableMember(), __metadata("design:type", AngularVelocityUnit)], AngularVelocity.prototype, "unit", void 0);
AngularVelocity = __decorate([SerializableObject(), __metadata("design:paramtypes", [Number, Number, Number, Object])], AngularVelocity);
export { AngularVelocity };